/**
 * Force une valeur d'option par défaut au chargement.
 *
 * Shopify retient la première variante disponible, soit la première valeur de la
 * liste — S sur une échelle S→XXL. Or l'ICP est à IMC 26-31, tours de taille
 * majoritairement entre 96 et 115 cm : le défaut naturel tombe deux crans sous
 * le cœur de cible. Une taille trop petite ne donne pas plus d'effet, elle crée
 * un bourrelet à la lisière et un retour — premier motif de retour sur du
 * vêtement de compression.
 *
 * On passe par un clic sur le contrôle natif plutôt que par une réécriture de
 * l'état : c'est la mécanique du thème qui met alors à jour le prix, les médias
 * et le bouton, sans qu'on ait à la dupliquer.
 */
(() => {
  const root = document.querySelector('[data-default-option][data-default-value]');
  if (!root) return;

  const optionName = root.dataset.defaultOption;
  const optionValue = root.dataset.defaultValue;
  if (!optionName || !optionValue) return;

  // Une variante explicite dans l'URL est un choix du visiteur — ou un lien
  // partagé. On ne la contredit jamais.
  if (new URLSearchParams(window.location.search).has('variant')) return;

  const apply = () => {
    const inputs = document.querySelectorAll(
      `input[type="radio"][data-option-name="${CSS.escape(optionName)}"]`
    );

    for (const input of inputs) {
      if (!(input instanceof HTMLInputElement)) continue;
      if (input.value !== optionValue) continue;
      if (input.checked) return;
      if (input.getAttribute('aria-disabled') === 'true') return;
      input.click();
      return;
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', apply, { once: true });
  } else {
    apply();
  }
})();
